import { userSelectors } from '../../../../actions';
import { Grid, useAppSelector } from '../../../../base';
import { ICompany } from '../../../../common';
import { CompanyLogoImg } from '../TopHeader.styles';

const CompanyLogo = () => {
    const companyInfo: ICompany =
        useAppSelector(userSelectors.getCompanyInfo) || ({} as ICompany);
    return (
        <>
            {companyInfo?.companyLogoUrl && (
                <Grid item>
                    <CompanyLogoImg src={companyInfo.companyLogoUrl} />
                </Grid>
            )}
        </>
    );
};

export default CompanyLogo;
